// Sede que se envia a la API de accesos. La lista de usuarios autorizados es
// unica y global: headquarter es cosmetico (obligatorio por la cadena de
// middleware) y siempre se persiste en CEDESCA en el backend. No hay selector
// de sede para esta pantalla.
export const ACCESOS_HEADQUARTER = 'CEDESCA';

// Tamano de pagina de la tabla de usuarios autorizados (paginacion en cliente).
export const PAGE_SIZE = 10;

// La propagacion del cambio al gate real tarda hasta ~60s (cache TTL en el
// servidor). Se avisa en la UI tras cada alta/revocacion.
export const PROPAGACION_AVISO =
  'Los cambios pueden tardar hasta 1 minuto en aplicarse en todas las instancias.';
